import React, { useEffect } from 'react';
import Header from './Header';

const AGBPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#E8F5E0] to-white">
      <Header />
      
      <div className="pt-24 pb-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            
            <div className="border-b-2 border-[#1A3A2E] pb-6 mb-8">
              <h1 className="text-4xl font-bold text-[#1A3A2E] mb-2">
                Allgemeine Geschäftsbedingungen
              </h1>
              <p className="text-gray-600">Allgemeine Geschäfts-, Leistungs- und Zahlungsbedingungen</p>
            </div>

            <div className="space-y-8 text-gray-800">
              {/* §1 */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-3">§1 Geltung der Bedingungen</h2>
                <p className="leading-relaxed">
                  Diese AGB gelten für alle Verträge zwischen der NOVATUS Energie GmbH (Auftragnehmer) und ihren Kunden (Auftraggeber). Sie gelten auch für künftige Verträge, wenn der Auftraggeber bei Vertragsschluss hierauf ausdrücklich hingewiesen wurde. Entgegenstehende oder abweichende Bedingungen des Auftraggebers gelten nur, wenn der Auftragnehmer diesen schriftlich zugestimmt hat.
                </p>
              </section>

              {/* §2 */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-3">§2 Auftragnehmer</h2>
                <p className="leading-relaxed">
                  Der Auftragnehmer ist auf die energetische Sanierung und Optimierung spezialisiert, insbesondere durch den Einsatz von Hybrid- und Wärmepumpensystemen sowie Photovoltaikanlagen (insbesondere PVT-Anlagen).
                </p>
              </section>

              {/* §3 */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-3">§3 Angebot und Vertragsabschluss</h2>
                <p className="leading-relaxed">
                  Angebote sind freibleibend. Ein Vertrag kommt durch Annahme des schriftlichen oder in Textform erteilten Angebots des Auftraggebers und schriftliche oder in Textform erteilte Bestätigung des Auftragnehmers zustande. Zeichnungen, Maße und Gewichte sind nur verbindlich, wenn schriftlich zugesichert.
                </p>
              </section>

              {/* §4 */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-3">§4 Fördermittel und Finanzierung</h2>
                <p className="leading-relaxed">
                  Sofern der Vertrag unter dem Vorbehalt staatlicher Förderung steht, endet der Vorbehalt mit Eingang der Förderzusage. Der Auftraggeber verpflichtet sich, alle erforderlichen Mitwirkungshandlungen vorzunehmen. Bleibt eine Förderzusage aus, können beide Vertragsparteien schriftlich vom Vertrag zurücktreten. Für Finanzierungen außerhalb staatlicher Förderung gilt Entsprechendes, wenn der Auftraggeber mindestens drei Ablehnungsbescheide innerhalb von drei Monaten nachweist.
                </p>
              </section>

              {/* §5 */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-3">§5 Preise</h2>
                <p className="leading-relaxed">
                  Alle Preise verstehen sich als Bruttopreise inkl. gesetzlicher Mehrwertsteuer, Verpackung, Lieferung, Transport und Altgeräteentsorgung (außer Heizöltanks und Brüstungsmauern). Fixpreise gelten nur, wenn ausdrücklich vereinbart.
                </p>
              </section>

              {/* §6 */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-3">§6 Pflichten der Vertragsparteien</h2>
                <p className="leading-relaxed">
                  Der Auftraggeber verpflichtet sich, den Gesamtpreis nach Maßgabe von §11 zu zahlen, die Leistung abzunehmen und Mitwirkungspflichten zu erfüllen. Der Auftragnehmer verpflichtet sich, die vertraglich vereinbarte Leistung zu erbringen, ggf. unter Einschaltung von Subunternehmern.
                </p>
              </section>

              {/* §7 */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-3">§7 Liefer- und Leistungszeit</h2>
                <p className="leading-relaxed">
                  Die Lieferzeit beträgt in der Regel 2-4 Wochen nach Anzahlungseingang. Bei höherer Gewalt (z. B. Streik, Naturereignissen) verlängert sich die Frist angemessen. Dauert die Behinderung länger als 12 Monate, kann jede Partei vom Vertrag zurücktreten. Schadensersatzansprüche bestehen nur bei vorsätzlicher oder grob fahrlässiger Pflichtverletzung.
                </p>
              </section>

              {/* §8 */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-3">§8 Gefahrübergang</h2>
                <p className="leading-relaxed">
                  Die Gefahr geht mit Übergabe oder Einbringung in den Einflussbereich des Auftraggebers über. Verzögert sich die Annahme durch den Auftraggeber, trägt er die Gefahr ab dem Zeitpunkt der Verzögerung.
                </p>
              </section>

              {/* §9 */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-3">§9 Gewährleistung</h2>
                <p className="leading-relaxed">
                  Für Verbraucher (§13 BGB) gilt eine Gewährleistungsfrist von 24 Monaten ab Abnahme. Für Unternehmer (§14 BGB) beträgt die Frist 12 Monate. Die Abnahme gilt erst als erfolgt, wenn der Auftraggeber nach Fertigstellung schriftlich zugestimmt hat oder spätestens 10 Werktage nach Fertigstellung ohne schriftlichen Widerspruch.
                </p>
              </section>

              {/* §10 */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-3">§10 Eigentumsvorbehalt</h2>
                <p className="leading-relaxed">
                  Die gelieferten und verbauten Gegenstände bleiben bis zur vollständigen Bezahlung Eigentum des Auftragnehmers. Der Auftraggeber verpflichtet sich, bei Zugriffen Dritter unverzüglich zu informieren.
                </p>
              </section>

              {/* §11 */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-3">§11 Zahlung</h2>
                <p className="leading-relaxed">
                  50% des Kaufpreises sind nach Auftragsbestätigung fällig, 30% bei Mitteilung der Ausführungsbereitschaft und 20% bei Inbetriebnahme. Bei Zahlungsverzug schuldet der Auftraggeber Verzugszinsen in Höhe von 5 Prozentpunkten über dem Basiszinssatz (§288 BGB). Aufrechnungen sind nur mit unbestrittenen oder rechtskräftig festgestellten Forderungen zulässig.
                </p>
              </section>

              {/* §12 */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-3">§12 Kostenersatz und Stornierung</h2>
                <p className="leading-relaxed">
                  Wird der Auftrag vor Ausführung auf Wunsch des Auftraggebers storniert oder wird die Ausführung der Arbeiten durch den Auftraggeber verhindert, ist der Auftraggeber verpflichtet, an den Auftragnehmer zum Ausgleich der entstandenen Aufwendungen einschließlich entgangenen Gewinns eine pauschale Entschädigung in Höhe von 25% der Auftragssumme zu zahlen. Dem Auftraggeber bleibt ausdrücklich der Nachweis vorbehalten, dass kein oder ein wesentlich geringerer Schaden entstanden ist. Der Auftragnehmer ist berechtigt, einen höheren tatsächlichen Schaden geltend zu machen, soweit dieser nachgewiesen wird.
                </p>
              </section>

              {/* §13 */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-3">§13 Haftung</h2>
                <p className="leading-relaxed">
                  Die Haftung des Auftragnehmers ist bei einfacher Fahrlässigkeit auf wesentliche Vertragspflichten (Kardinalpflichten) und den vertragstypischen vorhersehbaren Schaden beschränkt. Die Haftung bei Vorsatz, grober Fahrlässigkeit, Verletzung von Leben, Körper, Gesundheit sowie nach dem Produkthaftungsgesetz bleibt unberührt.
                </p>
              </section>

              {/* §14 */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-3">§14 Bauseitige Leistungen des Auftraggebers</h2>
                <p className="leading-relaxed">
                  Der Auftraggeber stellt erforderliche bauseitige Voraussetzungen (z. B. Gasanschluss, Fundament) auf eigene Kosten bereit. Dies gilt insbesondere für gasbetriebene Systeme und Wärmepumpen.
                </p>
              </section>

              {/* §15 */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-3">§15 Abtretung, Rechtswahl, Gerichtsstand</h2>
                <p className="leading-relaxed">
                  Der Auftragnehmer darf Forderungen abtreten. Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts. Bei Unternehmern ist Gerichtsstand der Sitz des Auftragnehmers. Verbraucher können Klagen an ihrem Wohnsitz erheben.
                </p>
              </section>

              {/* §16 */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-3">§16 Änderungen und Schriftform</h2>
                <p className="leading-relaxed">
                  Änderungen oder Ergänzungen bedürfen der Schriftform. Dies gilt nicht für Individualabreden. Die Schriftformklausel kann mündlich oder schriftlich geändert werden.
                </p>
              </section>

              {/* §17 */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-3">§17 Salvatorische Klausel</h2>
                <p className="leading-relaxed">
                  Sollten einzelne Bestimmungen unwirksam sein, bleibt der Vertrag im Übrigen wirksam. Die Parteien verpflichten sich, eine wirksame Regelung zu vereinbaren, die der unwirksamen wirtschaftlich am nächsten kommt.
                </p>
              </section>

              {/* §18 */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-3">§18 Widerrufsrecht</h2>
                <p className="leading-relaxed">
                  Verbrauchern steht ein Widerrufsrecht nach Maßgabe der gesonderten <a href="/widerruf" className="text-[#1A3A2E] hover:underline font-semibold">Widerrufsbelehrung</a> zu.
                </p>
              </section>

              {/* Unternehmensdaten */}
              <div className="mt-12 pt-8 border-t-2 border-[#1A3A2E]/20">
                <div className="bg-[#E8F5E0] p-6 rounded-lg">
                  <p className="font-bold text-[#1A3A2E] mb-2">NOVATUS Energie GmbH</p>
                  <p>Maximiliankorso 60, 13465 Berlin</p>
                  <p>Geschäftsführer: Christof Schirm</p>
                  <p>Amtsgericht Charlottenburg, HRB 222 580</p>
                  <p>USt.-ID-Nr.: DE 296 655 515</p>
                  <p className="mt-3">
                    <strong>Telefon:</strong> +49 (0)30 398205700<br/>
                    <strong>E-Mail:</strong> info@novatus-se.com
                  </p>
                  <p className="text-sm text-gray-600 mt-4">Stand: 19. Mai 2025</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="bg-[#1A3A2E] text-white py-8">
        <div className="container mx-auto px-4 text-center">
          <p className="text-sm">
            © {new Date().getFullYear()} NOVATUS Energie GmbH • Alle Rechte vorbehalten
          </p>
        </div>
      </div>
    </div>
  );
};

export default AGBPage;
